import apiClient from '../apiClient';
import { DELETE_RESTAURANT_BY_PROFILE_ID_URL } from '../apiUrl';

const deleteRestaurantByProfileIdApi = Id => {
  return apiClient.delete(DELETE_RESTAURANT_BY_PROFILE_ID_URL(Id));
};

export default deleteRestaurantByProfileIdApi;
